import { useCreateDocument } from "./useDocuments";
import { fileService } from "@/services/ServiceRegistry";
import { DocumentType } from "@/types/document";

export interface DocumentCreateData {
  bookingId: string;
  type: DocumentType;
  file: File;
  guestId: string;
}

export const useDocumentCreate = () => {
  const createDocumentMutation = useCreateDocument();

  const handleDocumentCreate = async (documentData: DocumentCreateData) => {
    try {
      let fileId: string;

      try {
        fileId = await fileService.uploadFileWithPresignedUrl(
          documentData.file
        );
      } catch (fileError) {
        console.error("Failed to upload document file:", fileError);
        throw new Error("Failed to upload document file");
      }

      await createDocumentMutation.mutateAsync({
        bookingId: documentData.bookingId,
        guestId: documentData.guestId,
        fileId: fileId,
        type: documentData.type,
      });
    } catch (error) {
      console.error("Failed to create document:", error);
      throw error;
    }
  };

  return {
    handleDocumentCreate,
    isLoading: createDocumentMutation.isPending,
    error: createDocumentMutation.error,
  };
};
